module.exports = __webpack_public_path__ + "static/media/PosibleLogo.919a5cde.png";